module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-logo-if3.640220b.jpg";